const parseError = (errors) => {
  let error = '';
  if (errors === Object(errors)) {
    Object.keys(errors).map((key, index) => {
      if (index === 0) {
        error = errors[key];
        if (Array.isArray(error)) {
          error = error[0];
        }
      }
    });
  }
  return error;
};

export default parseError;



// WEBPACK FOOTER //
// ./src/Utilities/Error.js